(function () {
  'use strict';
  if (window.FXObserveSwiper) return;
  var pending = new WeakMap();
  var library;
  var cssUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var jsUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  function loadStyle() {
    var existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).find(function (link) {
      return link.href === cssUrl;
    });
    if (existing) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      link.onload = resolve;
      link.onerror = function () {
        link.remove();
        reject(new Error('Swiper stylesheet unavailable'));
      };
      document.head.appendChild(link);
    });
  }

  function loadLibrary() {
    if (library) return library;
    var css = loadStyle();
    var js = typeof window.Swiper === 'function' ? Promise.resolve() : new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = jsUrl;
      script.async = true;
      script.onload = function () {
        if (typeof window.Swiper === 'function') resolve();
        else {
          script.remove();
          reject(new Error('Swiper did not initialize'));
        }
      };
      script.onerror = function () {
        script.remove();
        reject(new Error('Swiper script unavailable'));
      };
      document.head.appendChild(script);
    });
    library = Promise.all([css, js]).catch(function (error) {
      library = null;
      throw error;
    });
    return library;
  }

  function start(element) {
    var entry = pending.get(element);
    if (!entry || entry.busy || !element.isConnected) return;
    entry.busy = true;
    element.dataset.fxSwiperState = 'loading';
    loadLibrary().then(function () {
      if (!element.isConnected) return;
      entry.initialize();
      element.dataset.fxSwiperState = 'ready';
      pending.delete(element);
      element.removeEventListener('pointerdown', entry.activate);
      element.removeEventListener('focusin', entry.activate);
      if (observer) observer.unobserve(element);
    }).catch(function () {
      entry.busy = false;
      element.dataset.fxSwiperState = 'failed';
    });
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) start(entry.target);
    });
  }, { rootMargin: '1000px 0px' }) : null;

  window.FXObserveSwiper = function (element, initialize) {
    if (!element || !element.isConnected) return;
    var existing = pending.get(element);
    if (existing) {
      existing.initialize = initialize;
      return;
    }
    var entry = { initialize: initialize, busy: false };
    entry.activate = function () { start(element); };
    pending.set(element, entry);
    element.dataset.fxSwiperState = 'waiting';
    element.addEventListener('pointerdown', entry.activate, { passive: true });
    element.addEventListener('focusin', entry.activate);
    if (observer) observer.observe(element);
    else start(element);
  };
}());
